/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Delete_Confirm_DescriptionInputs */

const en_doc_delete_confirm_description = /** @type {(inputs: Doc_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This cannot be undone.`)
};

const pt_br2_doc_delete_confirm_description = /** @type {(inputs: Doc_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ação não pode ser desfeita.`)
};

/**
* | output |
* | --- |
* | "This cannot be undone." |
*
* @param {Doc_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_delete_confirm_description = /** @type {((inputs?: Doc_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Delete_Confirm_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_delete_confirm_description(inputs)
	return pt_br2_doc_delete_confirm_description(inputs)
});